import { isApproval } from '../../helpers/matchers'

export const titlesByType = {
  approval: 'Approval Phase',
  approvals: 'Approval Phase',
  task: 'Task Phase',
  tasks: 'Task Phase',
}

export const phaseSorter = (a, b) => a.position - b.position

export const getWorkflowIdentifiers = (props) => {
  if (props.postId) {
    return ['content', props.postId]
  }
  if (props.storyId) {
    return ['stories', props.storyId]
  }
  if (props.accountId) {
    return ['accounts', props.accountId]
  }
  if (props.workspaceId) {
    return ['workspaces', props.workspaceId]
  }
  if (props.localizationTemplatePostId) {
    return ['localization_template_posts', props.localizationTemplatePostId]
  }
  if (props.uuid && props.workflow && props.workflow.id) {
    return [null, null]
  }
  if (props.uuid) {
    return ['abstractWorkflow', props.uuid]
  }
  throw new Error(
    'No attachment identifier given. Could not determine type of workflow.'
  )
}

export const passesConditions = (conditions) => !conditions.includes(false)

export const setFinalApprovalPhase = (phases) => {
  const modifiedPhases = phases
  let index = modifiedPhases.length - 1
  let phase
  for (index; index >= 0; index -= 1) {
    phase = modifiedPhases[index]
    if (phase && phase.phase_type && isApproval(phase.phase_type)) {
      modifiedPhases[index].isFinalApproval = true
      break
    }
  }
  return modifiedPhases
}

export const shouldDisableAddButton = (phase) =>
  phase.is_active || phase.is_complete || phase.is_current

export const annotatedPhases = (isTemplate, workflowPhases) => {
  if (!workflowPhases || !workflowPhases.length) {
    return []
  }
  const phases = isTemplate
    ? workflowPhases
    : setFinalApprovalPhase(workflowPhases)
  const phaseCount = phases.length

  phases.map((phase) => {
    const modifiedPhase = phase
    modifiedPhase.isFirstPhase = false
    modifiedPhase.isLastPhase = false
    modifiedPhase.canAddBefore = !shouldDisableAddButton(modifiedPhase)
    modifiedPhase.canAddAfter = true

    return modifiedPhase
  })

  const sortedPhases = phases.sort(phaseSorter)
  sortedPhases[0].isFirstPhase = true
  sortedPhases[phaseCount - 1].isLastPhase = true
  return sortedPhases
}

export const newPhaseDefaults = (type) => ({
  autostart: true,
  due_date: null,
  name: titlesByType[type],
  phase_type: type,
})

const relevantFrameTypes = [
  'approval_phase_group',
  'approval',
  'phase',
  'post',
  'task',
]

export function needsPushBasedRefetch(props) {
  const lastFrame = props.lastFrame

  if (lastFrame && lastFrame.creator_guid === window.creator_guid) {
    return false
  }

  if (!relevantFrameTypes.includes(lastFrame && lastFrame.content_type)) {
    return false
  }

  if (lastFrame.content_type.match(/approval_phase_group/)) {
    if (
      (props.postId && props.postId.toString()) ===
      lastFrame.approvable_id.toString()
    ) {
      return true
    }
  }

  if ((props.postId && props.postId.toString()) === lastFrame.id.toString()) {
    return true
  }

  if (
    lastFrame.approvable_type &&
    lastFrame.approvable_type.match(/post/) &&
    lastFrame.approvable_id.toString() ===
      (props.postId && props.postId.toString())
  ) {
    return true
  }

  return false
}

export const findCompletedPhases = (phases = []) =>
  phases.filter((p) => p.status === 'complete')

export const shouldFetchWorkflow = ({ props, workflowType, attachmentId }) =>
  workflowType &&
  attachmentId &&
  props.getWorkflow &&
  (props.workflowLocation === 'workflowPopover' || props.isSessionTokenLoaded)
